<script>
  import { VERIFY_POPUP_CANCEL, VERIFY_POPUP_CONFIRM } from '../../js/l10n/en_US.js';

  function wrapperClicked() {
    if (!forceInteraction) {
      onClose();
    }
  }

  export let title = '',
    details = '',
    cancel = VERIFY_POPUP_CANCEL,
    confirm = VERIFY_POPUP_CONFIRM,
    forceInteraction = false,
    showCancel = true,
    visible = false,
    showTitleBar = true,
    onConfirm = () => {
      visible = false;
    },
    onClose = () => {
      visible = false;
    };

  export function openVerifyPopup(popupTitle, popupDetails, popupOnConfirm, popupOnClose) {
    onConfirm = () => {
      visible = false;
      popupOnConfirm();
    };
    onClose = () => {
      visible = false;
      if (!!popupOnClose) {
        popupOnClose();
      }
    };
    title = popupTitle;
    details = popupDetails;
    visible = true;
  }
</script>

{#if visible}
  <div class="verify-popup-wrap" on:click={wrapperClicked}>
    <div
      on:click={(event) => {
        event.stopPropagation();
      }}
      class="verify-popup">
      {#if showTitleBar}
        <div class="content-short-row verify-title-area">
          <div class="flex-row">
            <span>{title}</span>
            <i class="icon-close x" on:click={onClose} />
          </div>
        </div>
      {/if}
      <div class="verify-details-area">
        <slot>
          <span>{details}</span>
        </slot>
      </div>
      <div class="verify-buttons">
        {#if showCancel}
          <span class="verify-button cancel-button" on:click={onClose}>{cancel}</span>
        {/if}
        <span
          class="verify-button confirm-button {showCancel ? '' : 'confirm-no-cancel'}"
          on:click={onConfirm}>
          {confirm}
        </span>
      </div>
    </div>
  </div>
{/if}
